import { useMemo } from "react";

export const usePosition = (position: string, S: { [key: string]: string }) => {
    const positionClass = useMemo(() => {
        switch (position) {
            case "POSITION_FORM_LEFT":
                return S.positionFormLeft;
            default:
                return S.positionFormRight;
        }
    }, [position, S]);

    return {
        positionClass,
    };
};
